var map = {
	"./0.png": 3503,
	"./0_dark.png": 254,
	"./1.png": 1450,
	"./2.png": 2129,
	"./3.png": 6129,
	"./4.png": 6115,
	"./5.png": 7057,
	"./6.png": 55,
	"./7.png": 9372,
	"./8.png": 3543,
	"./9.png": 1808,
	"./home.png": 7728,
	"./map.png": 6354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4310;